import wx from 'weixin-js-sdk';
import { getWxSign } from 'common/js/getSDKSign';
import api from 'api/user';
export default {
  created() {
    //微信签名
    getWxSign();
  },
  methods: {
    //继续支付
    async gotoPay(orderSn) {
      let that = this;
      const sign = await api.payByJSSDK(orderSn);
      wx.chooseWXPay({
        timestamp: sign.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: sign.nonceStr, // 支付签名随机串，不长于 32 位
        package: sign.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: sign.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: sign.paySign, // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
          that.$router.push({
            path: '/order-success',
            /*query: {
              orderNum: data,
            },*/
          });
        },
        cancel: function (res) {
          console.log(res);
          that.$router.push({
            path: '/order',
          });
        }
      });
    },
  }
}